
import { Box, Textarea, Input, Heading, Flex, Button, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { addTeacherProfile } from "../../../../../services/adminService";

const AddTeachers = (clerkId) =>{
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [photo, setPhoto] = useState(null);
    const toast = useToast();

    const handleSave= async() =>{
        const teacherData = {
            name,
            description,
        };
        try{
            const response = await addTeacherProfile(teacherData, photo, clerkId);
            if (response.ok){
              toast({
                title: 'Teacher added.',
                description: 'Teacher profile has been added successfully.',
                status: 'success',
                duration: 3000,
                isClosable: true,
              });
            } else{
              toast({
                title: 'error',
                description: 'error while trying to add teacher profile.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
            }
            console.log('Teacher profile added succesfully')
        } catch(error){
            console.log(error);
        }
    }

    const handlePhotoChange = (e) => {
        const selectedFile = e.target.files[0];
        setPhoto(selectedFile);
        console.log("Selected photo:", selectedFile); 
      };

    return(
        <Box>
        <Heading mb={4}>Add new teachers</Heading>
        <Input
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        mb={4}
        dir="rtl"
      />
      <Textarea
        placeholder="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        mb={4}
        dir="rtl"
      />
      <Input
        type="file"
        accept="image/*"
        onChange={handlePhotoChange}
        mb={4}
        dir="rtl"
      />
      <Flex mt={4}>
        <Button
            colorScheme="green"
            onClick={handleSave}
            mr={2}
            isDisabled={!photo}
        >
            Upload
        </Button>
      </Flex>
      </Box>
    )
}

export default AddTeachers;